export default __webpack_public_path__ + "static/media/partner-web.d4ec356a.webp";